// Кеш відповідності (pluginId, path) → слаг короткого посилання, у
// localStorage браузера. Синхронний — саме тому workHref() в utils.ts може
// одразу (без запиту на сервер, без "спалаху" старої адреси) повернути
// готове коротке посилання /<pluginId>/<слаг>, якщо воно вже колись
// резолвилось раніше (на цьому чи іншому пристрої — кеш підхоплюється й
// напряму з window.__PRETTY__, коли сторінку відкрито за коротким
// посиланням, див. utils.ts:qs()/switchToPrettyUrl()).

const PREFIX = 'pretty:';

function cacheKey(pluginId: string, novelPath: string): string {
  return `${PREFIX}${pluginId}::${novelPath}`;
}

export function getCachedSlug(pluginId: string, novelPath: string): string | undefined {
  try {
    return localStorage.getItem(cacheKey(pluginId, novelPath)) ?? undefined;
  } catch {
    return undefined;
  }
}

export function setCachedSlug(pluginId: string, novelPath: string, slug: string): void {
  try {
    localStorage.setItem(cacheKey(pluginId, novelPath), slug);
  } catch {
    /* localStorage недоступний (приватний режим тощо) — просто без кешу, не критично */
  }
}

/** Масово реєструє/дізнається слаги на сервері та кладе їх у кеш — щоб
 * посилання на вже відображені у списку твори (бібліотека/огляд/нове/
 * історія) встигли стати короткими ДО того, як користувач по них клацне.
 * Викликається у фоні, після відмальовки списку; на завершенні колбек
 * onReady дозволяє оновити вже намальовані href на елементах. */
export async function warmSlugCache(
  items: { pluginId: string; path: string; title: string }[],
  onReady?: () => void,
): Promise<void> {
  const need = items.filter((it) => it.title && !getCachedSlug(it.pluginId, it.path));
  if (!need.length) {
    onReady?.();
    return;
  }
  try {
    const res = await fetch('/api/plugins/slugs', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: need.map((it) => ({ plugin: it.pluginId, path: it.path, title: it.title })) }),
    });
    if (!res.ok) return;
    const data: { slug: string; plugin: string; path: string }[] = (await res.json()).slugs ?? [];
    for (const row of data) setCachedSlug(row.plugin, row.path, row.slug);
    onReady?.();
  } catch {
    /* без короткого посилання нічого не ламається — просто лишається старий формат */
  }
}
